import React, { useEffect, useRef } from "react";
import { Box, Typography, Container, Button } from "@mui/material";
import { toast } from "react-toastify";
import PaginatedListLayout from "../../../shared/pagination/PaginatedListLayout";
import CompanyTable from "../../shared/CompanyTable";
import ConfirmStopModal from "../../../shared/ConfirmStopModal";
import useCompanies from "../../hooks/useCompanies";

/**
 * 企業一覧ページ
 */
export default function CompanyIndexPage({ flashMessage }) {
  const {
    companies,
    loading,
    pagination,
    showDialog,
    fetchCompanies,
    saveCompanyUsers,
    openDeleteDialog,
    closeDeleteDialog,
    deleteCompany,
    fieldErrorsByCompany,
    clearCompanyFieldErrors,
  } = useCompanies();

  const hasShownFlash = useRef(false);

  // 企業登録ページへ遷移（Rails側へフルリロード）
  const goToCompanyNew = () => {
    window.location.href = "/company_new";
  };

  // typeに応じてトースト表示
  const showToastByType = (type, message) => {
    const fn = toast[type] || toast;
    fn(message);
  };

  // 初回のみフラッシュメッセージを表示（重複表示防止）
  useEffect(() => {
    if (!flashMessage || hasShownFlash.current) return;

    hasShownFlash.current = true;

    // flashMessageが文字列でもオブジェクトでも扱えるよう正規化
    const { message, type = "success" } =
      typeof flashMessage === "object"
        ? flashMessage
        : { message: flashMessage };

    showToastByType(type, message);
  }, [flashMessage]);

  // ローディング表示（データ未取得かつ取得中）
  const isInitialLoading = loading && companies.length === 0;

  if (isInitialLoading) {
    return (
      <Container maxWidth="md" sx={{ mt: 4, mb: 10 }}>
        <Typography>読み込み中...</Typography>
      </Container>
    );
  }

  return (
    <>
      <Container sx={{ mt: 4, mb: 10 }}>
        <Box
          sx={{
            position: "sticky",
            top: "63px",
            zIndex: 20,
            backgroundColor: "#F4F7FA",
            boxShadow: 0,
            mx: -2,
            px: 2,
            pt: 1.5,
          }}
        >
          <Box display="flex" justifyContent="space-between" mb={1}>
            <Typography variant="h5" fontWeight="bold">
              企業一覧
            </Typography>
            <Button
              variant="outlined"
              onClick={goToCompanyNew}
              sx={{ fontWeight: "bold" }}
            >
              ＋ 追加
            </Button>
          </Box>
        </Box>

        <PaginatedListLayout
          items={companies}
          loading={loading}
          pagination={pagination}
          onPageChange={fetchCompanies}
          emptyText="企業データがありません。"
        >
          <CompanyTable
            companies={companies}
            pagination={pagination}
            onSave={saveCompanyUsers}
            onDelete={openDeleteDialog}
            fieldErrorsByCompany={fieldErrorsByCompany}
            clearCompanyFieldErrors={clearCompanyFieldErrors}
          />
        </PaginatedListLayout>
      </Container>

      <ConfirmStopModal
        open={showDialog}
        onClose={closeDeleteDialog}
        onConfirm={deleteCompany}
        title="企業を削除"
        message="企業を削除すると元に戻せません。"
        confirmLabel="削除する"
      />
    </>
  );
}
